/*
 * @Author: wangshengqiang
 * @Date: 2022-01-04 15:06:27
 * @LastEditTime: 2022-01-04 15:14:09
 * @LastEditors: wangshengqiang
 * @Description: 银行账号类型 账号类型 01-借记卡 02-存折 03-贷记卡
 */
import React from 'react';
import RowSelect from '../RowSelect';
export default function Banks(props) {
  return /*#__PURE__*/React.createElement(RowSelect, props);
}
;